import { apiClient } from "@/lib/api-client";
import { normaliseFavResponse } from "@/services/utils/responseHelpers";

/** Toggle favorite on/off for a listing */
export const toggleFavorite = async (listingId: string) => {
  const res = await apiClient.post(`/v1/favorites/${listingId}/toggle`);
  return normaliseFavResponse(res);
};

/** Get all of the current user's favorites */
export const getAllFavorites = async () => {
  const res = await apiClient.get("/v1/favorites");
  return res.data ?? res;
};
